esSizeAdvisorJsonp([5],{

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.EasySize = EasySize;

var _qwery = __webpack_require__(3);

var _qwery2 = _interopRequireDefault(_qwery);

var _bean = __webpack_require__(7);

var _bean2 = _interopRequireDefault(_bean);

var _features = __webpack_require__(1);

var _utilities = __webpack_require__(2);

var _easysizePreStart = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EasySize(opts, params) {
  /*
        Reset Easysize on SPA based shops
    */
  if (window.EasysizeStarted) {
    (0, _utilities.debug)('Reinitiating Easysize');
    _features.emitter.allOff();
    _bean2.default.off(document);
    _bean2.default.off(window);
    (0, _utilities.removeElementsByClassName)('es-selected');
    (0, _utilities.removeElementsByClassName)('es-recommended');
    (0, _utilities.removeElementsByClassName)('easysize_button');

    document.body.classList.remove('es-recommended-size');
    document.body.classList.remove('es-selected-size');
    params = (0, _easysizePreStart.preEasysize)();
  }

  // Fix window.location.origin on ie browsers
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }

  /*
        Polyfills
     */

  // Array max
  Array.max = function (array) {
    return Math.max.apply(Math, array);
  };

  // Array min
  Array.min = function (array) {
    return Math.min.apply(Math, array);
  };

  // Object.assign
  if (typeof Object.assign !== 'function') {
    (function () {
      Object.assign = function (target) {
        'use strict';
        // We must check against these specific cases.

        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source !== undefined && source !== null) {
            for (var nextKey in source) {
              if (source.hasOwnProperty(nextKey)) {
                output[nextKey] = source[nextKey];
              }
            }
          }
        }
        return output;
      };
    })();
  }

  /* eslint-disable no-unused-vars */
  function defineProperties(obj, properties) {
    function convertToDescriptor(desc) {
      function hasProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
      }

      function isCallable(v) {
        // NB: modify as necessary if other values than functions are callable.
        return typeof v === 'function';
      }

      if ((typeof desc === 'undefined' ? 'undefined' : _typeof(desc)) !== 'object' || desc === null) {
        throw new TypeError('bad desc');
      }

      var d = {};

      if (hasProperty(desc, 'enumerable')) {
        d.enumerable = !!desc.enumerable;
      }
      if (hasProperty(desc, 'configurable')) {
        d.configurable = !!desc.configurable;
      }
      if (hasProperty(desc, 'value')) {
        d.value = desc.value;
      }
      if (hasProperty(desc, 'writable')) {
        d.writable = !!desc.writable;
      }
      if (hasProperty(desc, 'get')) {
        var g = desc.get;

        if (!isCallable(g) && typeof g !== 'undefined') {
          throw new TypeError('bad get');
        }
        d.get = g;
      }
      if (hasProperty(desc, 'set')) {
        var s = desc.set;
        if (!isCallable(s) && typeof s !== 'undefined') {
          throw new TypeError('bad set');
        }
        d.set = s;
      }

      if (('get' in d || 'set' in d) && ('value' in d || 'writable' in d)) {
        throw new TypeError('identity-confused descriptor');
      }

      return d;
    }

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
      throw new TypeError('bad obj');
    }

    properties = Object(properties);

    var keys = Object.keys(properties);
    var descs = [];

    for (var i = 0; i < keys.length; i++) {
      descs.push([keys[i], convertToDescriptor(properties[keys[i]])]);
    }

    for (var _i = 0; _i < descs.length; _i++) {
      Object.defineProperty(obj, descs[_i][0], descs[_i][1]);
    }

    return obj;
  }

  // default EasySize button text
  var easysizeBtnTextPrimary = 'Find my size';
  var easysizeBtnTextSecondary = 'Just 5 clicks away';
  var easysizeReturningUserText = "✓ This size is recommended by {n} customers. <span class='easysize_button__returning'>Find my size again.</span><span class='es-size-explanation'>These users have bought recommended size without returning.</span>";
  var easysizeReturningUserTextOutOfStock = "<span class='easysize_button__returning'>✓ Your recommended size {s} is not in stock.</span>";
  var easysizeRecommendedSizeText = '✓ The recommended size has been selected.';

  // Mandatory data:
  params.product.id = opts.product_id || null;
  params.product.stock = opts.sizes_in_stock || null;
  params.product.fits_in_stock = opts.fits_in_stock || {};
  params.product.image_url = opts.image_url || null;
  params.product.fit = opts.product_fit || false;
  params.product.model = opts.product_model || false;
  params.product.title = opts.product_title || opts.title || null;
  params.product.sku = opts.product_sku || false;
  params.product.supported = false;
  params.product.tags = opts.product_tags || [];
  params.product.variants = opts.product_variants || [];
  params.product.options = opts.product_options || [];
  params.product.available_fits = opts.available_fits || [];
  params.product.available_lengths = opts.available_lengths || [];
  params.product.selected_options = opts.selected_options || [];

  params.easysize.product = 'size-advisor';
  params.easysize.loaded = opts.loaded ? opts.loaded : false;
  params.easysize.is_loaded = false;
  params.easysize.demo_mode = opts.demo_mode ? opts.demo_mode : false;
  params.easysize.widget_iframe_attributes = opts.widget_iframe_attributes || {};
  params.easysize.tracking_started = false;
  params.easysize.dom_updates = opts.dom_updates === false ? false : true;

  if (!window.VPmonkeyPatch) {
    params.product.brand = opts.product_brand || null;
    params.product.gender = (0, _features.findGender)(opts.product_gender) || '-';
    params.product.category = opts.product_type.split(',') || null;
  }

  if (params.product.stock) {
    for (var size in params.product.stock) {
      if (params.product.stock.hasOwnProperty(size)) {
        params.product.stock[size] = parseInt(params.product.stock[size]);
      }
    }
  }

  // backward compatibility for old parameter named order_button_id
  params.shop.add_to_cart = opts.add_to_cart || null;
  params.shop.add_to_cart_btn_selector = opts.add_to_cart_btn_selector || opts.order_button_id || null;
  params.shop.size_dropdown_selector = opts.size_dropdown_selector || opts.size_selector || null;
  params.shop.easysize_button_placeholder_selector = opts.placeholder || null;
  params.shop.recommendation_placeholder = opts.recommendation_placeholder || null;

  params.shop.generated_shop_id = opts.shop_id || null;
  if (window.VPmonkeyPatch) {
    // eslint-disable-line
    params.shop.update_size_dropdown = opts.size_update_function || opts.uptCallback || __webpack_require__(1).updateSizeVP;
  } else {
    params.shop.update_size_dropdown = opts.size_update_function || opts.uptCallback || __webpack_require__(1).updateSize;
  }

  // Keep original size update function for placeholder predictions
  params.shop.original_size_update_function = opts.size_update_function;

  params.shop.language = opts.language || null;
  params.shop.user_id = opts.user_id || null;
  if (window.VPmonkeyPatch) {
    // eslint-disable-line
    params.shop.vp_monkey_patch = true;
  }
  params.shop.cookies_enabled = opts.hasOwnProperty('cookies_enabled') ? opts.cookies_enabled : true;

  // Allow shops control of the button text
  params.shop.new_user_text = opts.new_user_text || null;
  params.shop.returning_user_text = opts.returning_user_text || null;
  params.shop.tags = opts.tags || [];

  params.shop.initial_custom_css = opts.custom_css || "";
  params.shop.custom_css = opts.custom_css || "";
  params.shop.size_guide_url = opts.size_guide_url || false;

  // Features
  params.features.returning_user_mode = !opts.disableReturningCustomer;
  params.features.size_advisor = true;

  // EasySize button text customization
  params.button.primary_text = opts.es_btn_text1 || easysizeBtnTextPrimary;
  params.button.secondary_text = opts.es_btn_text2 || easysizeBtnTextSecondary;
  params.button.returning_user_text = opts.rsr_text || easysizeReturningUserText;
  params.button.returning_user_text_out_of_stock = easysizeReturningUserTextOutOfStock;
  params.button.recommended_size_text = opts.rs_text || easysizeRecommendedSizeText;
  params.button.predict = true;

  // Button placement
  params.elements.button_n_position = 'after';
  params.elements.button_r_position = 'after';

  params.track = function (action) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!action) {
      return;
    }
    if (!params.easysize.tracking_started) {
      /* Try tracking again in one second, in case pageview is not yet set */
      setTimeout(function () {
        (0, _utilities.debug)('Repeating tracking as no pageview is yet set');
        params.track(action, value);
      }, 1000);
    }
  };

  new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1)).then(function (module) {
    module.bindEasysizeMessages(params);
    module.loadEasySizeStyle(params);
  });

  function checkProduct(params) {
    if (params.button.loaded_from_server) {
      new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1)).then(function (module) {
        module.checkProduct(params);
      });
    } else {
      setTimeout(function () {
        checkProduct(params);
      }, 50);
    }
  }

  return {
    start: function start() {
      params.elements.add_to_cart_button = (0, _qwery2.default)(params.shop.add_to_cart_btn_selector)[0];
      params.elements.button_placeholder = (0, _qwery2.default)(params.shop.easysize_button_placeholder_selector.constructor === Array ? params.shop.easysize_button_placeholder_selector[0] : params.shop.easysize_button_placeholder_selector)[0];
      params.elements.size_dropdown = (0, _qwery2.default)(params.shop.size_dropdown_selector)[0];

      window.EasysizeStarted = true;

      params.shop.current_meta_viewport = false;
      try {
        var currentMetaViewport = (0, _qwery2.default)('meta[name=viewport]');
        currentMetaViewport = currentMetaViewport[currentMetaViewport.length - 1];
        params.shop.current_meta_viewport = currentMetaViewport.content;
      } catch (e) {
        (0, _utilities.debug)('[EasySize] No meta viewport', e);
      }

      checkProduct(params);
    },
    update_product: function update_product(config) {
      params.product = Object.assign(params.product, config);
    },
    embed: function embed(config) {
      if (params.product.supported) {
        new Promise(function(resolve) { resolve(); }).then((function (require) {
          __webpack_require__(0).embed(params, config);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      } else {
        console.warn('[Easysize] trying to open widget when product is not supported');
      }
    },
    open: function open(config) {
      // Prevent widget from being opened multiple times
      if (document.getElementById('easysize_popup')) {
        return;
      }

      params.shop.custom_css = config.custom_css || params.shop.custom_css;

      if (params.product.supported) {
        new Promise(function(resolve) { resolve(); }).then((function (require) {
          __webpack_require__(0).startQaAdvisor(params);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      } else {
        console.warn('[Easysize] trying to open widget when product is not supported');
      }
    },

    sizeChangedTo: function sizeChangedTo(size) {
      _features.emitter.emit('easysize_size_selected', size);
      params.shop.selected_size = size;
    },

    restart: function restart() {
      _features.emitter.allOff();
      _bean2.default.off(document);
      _bean2.default.off(window);
    }
  };
}

/***/ })

});


// WEBPACK FOOTER //
// chunks/easysize.a8fe2de319e272294e97.js